module.exports = __webpack_public_path__ + "img/speak6.93c73bc4.png";